// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2UXb5","col":"styles_col__3sOR3"};